import { EventsCacheLockId } from '../schema/EventsCache';

let nextLockIdNum = 0;
export function createEventsCacheLockId(): EventsCacheLockId {
    const lockId = `events_cache_lock_${nextLockIdNum}`;
    nextLockIdNum++;

    return lockId as EventsCacheLockId;
}
